<template>
  <div class="main-container myorder mt30">
<!--    <code>    {{ orders }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">
        <div class="col-md-12">
          <div>
            <div class="income_summary animated slideInUp">
              <p>Increase Sales  &  Increase  your  <br><b>Sales Commission !!</b></p>
              <img src="@/assets/images/up.png" alt="alt">
              <p><span>&#2547; <span class="animated bounceIn">{{sales_commission}}</span></span> <br>
                <b>Sales Commission</b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 20);
      });

  });

  import axios from 'axios';

  export default {
    data() {
      return {
        token: '',
        sales_commission: 0,
        getcarts: [],
        modalProductData: [],
        recentViews: [],
        categories: [],
        carts: [],
        loadMore: true,
        isOpen: true,
        sum_cart_total: '',
        quantity: 1,
        images: [],
        parseCartData: [],
        changeModalGallery_image: '',
        fullname: '',
        deliveryAddress: '',
        order_items: [],
        name: '',
        email: '',
        finalOrderStatus: '',
        phone: '',
        country: '',
        district: '',
        area: '',
        zip: '',
        address: '',
      };
    },
    created: function () {
      this.loadApiData();
    },
    methods: {
      loadApiData: function () {
        let vm = this;
          let logged_in_user_id = localStorage.getItem('logged_in_user_id');

          axios.get(this.globalUrl+"marketer/"+logged_in_user_id)
            .then(function (response) {
              console.log(response);
              if(response.data.affiliate_commission>0){
                vm.sales_commission = response.data.affiliate_commission;
              }
            })
            .catch((response) => {
            });
        }
    }
  };
</script>
